(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const sliderSections = document.querySelectorAll('[class*="image-text-slider1-"]');

  sliderSections.forEach(slider => {
    const slides = slider.querySelectorAll('.slide');
    const wrapper = slider.querySelector('.testimonials-wrapper');

    // Force 1 slide per view on mobile
    let slidesPerView = parseInt(slider.dataset.slidesPerView) || 1;
    if (window.innerWidth < 768) slidesPerView = 1;

    const autoplayEnabled = slider.dataset.autoplay === "true";
    let autoplayDelay = parseInt(slider.dataset.autoplaySpeed) || 4000;
    if (autoplayDelay < 1000) autoplayDelay = 1000;
    if (autoplayDelay > 10000) autoplayDelay = 10000;

    let currentSlide = 0;
    const totalPages = slides.length - slidesPerView + 1;

    slides.forEach(slide => {
      slide.style.flex = `0 0 ${100 / slidesPerView}%`;
    });

    const pagination = slider.querySelector('.slider-pagination');
    pagination.innerHTML = "";
    for (let i = 0; i < totalPages; i++) {
      const dot = document.createElement("span");
      dot.classList.add("pagination-dot");
      if (i === 0) dot.classList.add("active");
      dot.dataset.index = i;
      pagination.appendChild(dot);
    }
    const dots = pagination.querySelectorAll(".pagination-dot");

    function updateDots(index) {
      dots.forEach(dot => dot.classList.remove("active"));
      dots[index].classList.add("active");
    }

    function showSlide(index) {
      currentSlide = index;
      wrapper.style.transform = `translateX(-${100 / slidesPerView * currentSlide}%)`;
      updateDots(currentSlide);
    }

    dots.forEach(dot => {
      dot.addEventListener("click", () => showSlide(parseInt(dot.dataset.index)));
    });

    let autoplay;
    function startAutoplay() {
      if (autoplayEnabled) {
        autoplay = setInterval(() => {
          currentSlide = (currentSlide + 1) % totalPages;
          showSlide(currentSlide);
        }, autoplayDelay);
      }
    }
    function stopAutoplay() {
      if (autoplay) clearInterval(autoplay);
    }

    startAutoplay();
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    showSlide(0);
  });
});

  } catch(e) { console.error(e); }
})();
})();
